/**
 * Styled Components - Created by cazarez on 14/05/18.
 */
import Icon from 'antd/lib/icon'
import TextArea from 'antd/lib/input/TextArea'
import styled from 'styled-components'
import Caroussel from 'react-slick'
import { BLACK_BG } from '../../theme/colors'

interface DivProps {
  secondary?: boolean
  preview?: boolean
}

export const buttonStyle = {
  backgroundColor: 'white',
  opacity: 0,
}

export const Container = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  font-family: Avenir;
  color: rgb(54, 69, 79);
  #fitsTitle {
    font-size: 14px;
    color: #2b2b2c;
    text-align: center;
    margin: 6px 0 12px;
  }
  #fitsSubtitle {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: flex-end;
    position: relative;
    margin-top: -12px;
  }
  #videoPlchldr {
    height: 248px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f3f3f3;
    padding: 18px;
    margin-top: 12px;
    border-radius: 5px;
  }
  .hyperlink {
    font-size: 13px;
    margin-top: 7px;
    text-decoration: underline;
    text-align: center;
    &:hover {
      cursor: pointer;
      color: cornflowerblue;
    }
  }
`

export const CarousselDiv = styled(Caroussel)`
  display: inline-grid !important;
  .slick-prev {
    left: 0px !important;
    z-index: 2;
  }
  .slick-next {
    right: 0px !important;
    z-index: 2;
  }
  .slick-slide {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }
`

export const StepCard = styled.div`
  text-align: center;
  border-radius: 5px;
  margin-right: 22px;
  width: 124px;
  display: flex;
  flex-flow: column;
  align-items: center;
  position: relative;
  background: #a9a9a92e;
`

export const ThumbnailStepContainer = styled.div`
  display: flex;
  flex-flow: column;
  justify-items: center;
  width: 100%;
`

export const ThumbnailStep = styled.img`
  max-width: 100%;
  min-height: 76px;
  object-fit: cover;
  padding: 6px;
`

export const CurrentThumbnail = styled.img`
  max-width: 136px;
  height: 112px;
  object-fit: cover;
  margin-bottom: 8px;
`

export const FitPreferenceTextContainer = styled.div`
  padding-top: 24px;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
`

export const FitPreferenceText = styled.div`
  font-size: 20px;
  color: ${BLACK_BG};
`

export const FitPreferences = styled.div`
  display: flex;
  margin-top: 12px;
  @media(min-width: 320px) and (max-width: 768px) {
    flex-direction: row;
    flex-wrap: wrap;
  }
  @media (max-width: 698px) {
    justify-content: center;
  }
`

export const FitCard = styled.div`
  display: flex;
  flex-flow: column;
  text-align: center;
  max-width: 270px;
  width: 100%;
  margin-right: 22px;
  box-shadow: 1px 1px 6px -1px #3f3f3f;
  border-radius: 5px;
  background: white;
  position: relative;
  color: #5F6062;
  transition: all .25s;
  &:last-child {
    margin-right: 0px;
  }
  ${({ secondary }: DivProps) => secondary ? `
    background: ${BLACK_BG};
    box-shadow: 0px 0px 3px 1px greenyellow;
    color: white;
  ` : ''}
  @media (max-width: 768px) {
    max-width: 148px;
    margin-right: 4px;
    margin-top: 4px;
  }
  @media (max-width: 698px) {
    max-width: 122px;
    margin-right: 10px;
    margin-bottom: 12px;
    margin-top: 0px;
  }
`

export const FitImage = styled.img`
  width: 100%;
  max-height: 232px;
  object-fit: cover;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  @media (max-width: 698px) {
    max-height: 152px;
  }
`

export const FitVideo = styled.video`
  width: 100%;
  max-height: 100vh;
  object-fit: cover;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  @media (max-width: 698px) {
    max-height: 152px;
  }
`

export const LoadingImage = styled.div`
  position: absolute;
  z-index: 2;
  background: #ffffff63;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const FitDetailsButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 4px;
  flex: 1;
  justify-content: flex-end;
  margin-top: 4px;
`

export const FitSelectStateButton = styled.div<{$selected: boolean}>`
  max-width: fit-content;
  margin-bottom: 4px;
  background: ${props => props.$selected ? '#8fd14f' : BLACK_BG};
  color: ${props => props.$selected ? BLACK_BG : 'white'};
  font-size: 12px;
  text-transform: uppercase;
  padding: 4px 22px;
  border-radius: 3px;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    background: ${BLACK_BG};
    color: white;
    box-shadow: 0px 0px 2px 1px #8fd14f;
  }
`

export const FitDetailsButton = styled.div`
  border: 1px solid #397bc0;
  max-width: fit-content;
  margin-bottom: 4px;
  background: white;
  color: #397bc0;
  font-size: 12px;
  padding: 0px 10px;
  border-radius: 3px;
  &:hover {
    cursor: pointer;
    background: #397bc0;
    color: white;
  }
`

export const ExpandIconContainer = styled(Icon)`
  display: flex;
  align-items: center;
  justify-content: right;
  max-width: fit-content;
  font-size: 16px;
  border-radius: 3px;
  padding: 4px;
  background: #00000061;
  color: white;
  position: absolute;
  top: 168px;
  right: 4px;
  @media (max-width: 768px) {
    top: 4px;
    font-size: 14px;
    padding: 2px;
  }
  &:hover {
    cursor: pointer;
    background: black;
  }
`

export const FitTitle = styled.div`
  margin-top: 6px;
  color: ${({ secondary }: DivProps) => secondary ? 'white' : '#1d6d84'};
  font-weight: bold;
  transition: color .25s;
  text-align: center;
`

export const FitDescription = styled.div`
  font-size: 12px;
  padding: ${({ preview }: DivProps) => preview ? '6px 14px' : '4px 4px'};
  @media (max-width: 768px) {
    display: ${({ preview }: DivProps) => preview ? 'block' : 'none'};
    padding: ${({ preview }: DivProps) => preview ? '14px' : '4px'};
  }
`

export const CheckCorner = styled.div`
  border: 1px solid #898989;
  position: absolute;
  height: 16px;
  width: 16px;
  border-radius: 3px;
  top: 6px;
  right: 8px;
  z-index: 2;
  background: white;
  ${({ secondary }: DivProps) => secondary ? `
    background: darkseagreen;
    border-color: darkseagreen;
    &:before {
      content: "✓";
    }
  ` : ''}
`

export const CheckBoxFit = styled.div`
  border: 1px solid black;
  position: absolute;
  height: 18px;
  width: 18px;
  border-radius: 3px;
  padding-left: 2px;
  top: 6px;
  right: 8px;
  ${({ secondary }: DivProps) => secondary ? `
    background: #8de98d;
    border-color: #8de98d;
    &:before {
      content: "✓";
    }
  ` : ''}
`

export const CloseIcon = styled(Icon)`
  position: absolute;
  right: 16px;
  top: 16px;
  background: #405487;
  color: white;
  border-radius: 25px;
  padding: 4px;
  &:hover {
    cursor: pointer;
  }
`
export const CloseFitCardIcon = styled(Icon)`
  position: absolute;
  right: -7px;
  top: -7px;
  border: 1px solid white;
  background: ${BLACK_BG};
  color: white;
  border-radius: 25px;
  padding: 4px;
  font-size: 12px;
  z-index: 2;
  &:hover {
    cursor: pointer;
  }
`

export const CloseStepCardIcon = styled(Icon)`
  position: absolute;
  right: 6px;
  top: 6px;
  font-size: 12px;
  &:hover {
    cursor: pointer;
    color: red;
  }
`

export const SelectedStepCardIcon = styled(Icon)`
  position: absolute;
  left: 6px;
  top: -6px;
  background: #59ce25;
  color: white;
  font-size: 8px;
  border-radius: 25px;
  padding: 4px;
  &:hover {
    cursor: pointer;
  }
`
export const StepFitLabel = styled.div`
  width: 100%;
  position: relative;
  font-size: 10px;
  color: white;
  font-weight: bold;
  background: ${BLACK_BG};
  padding: 6px;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
`

export const BottomSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: flex-end;
  margin-top: 22px;
  @media(min-width: 320px) and (max-width: 768px) {
    flex-direction: column;
    gap: 10px;
  }
`

export const DesignNotesLabel = styled.div`
  display: flex;
  gap: 6px;
  span:first-child {
    color: ${BLACK_BG};
    font-weight: 500;
  }
  span:last-child {
    color: #d1d1d1;
  }
`

export const DesignNotes = styled(TextArea)`
  min-width: 390px;
  outline: none;
  box-shadow: none;
  background: rgb(229, 228, 226, 0.3);
  border: 1px solid #5772b5;
  color: #36454F;
  &:hover {
    border-color: cornflowerblue;
    box-shadow: none;
  }
  &:focus {
    box-shadow: none;
    border-color: #A9A9A9;
  }
  @media(width > 400px) and (width <= 768px) {
    min-width: 290px;
  }
  @media(width < 400px) {
    min-width: 270px;
  }
`

export const ActionButton = styled.div`
  background: ${({ secondary }: DivProps) => secondary ? '#b9b9b9' : BLACK_BG};
  font-weight: 500;
  font-family: Avenir;
  padding: 8px;
  width: 146px;
  border-radius: 25px;
  margin-left: 20px;
  text-align: center;
  transition: all .25s;
  color: white;
  &.close {
    background: white;
    border: 1px solid ${BLACK_BG};
    color: ${BLACK_BG};
    padding: 7px;
    width: 144px;
  }
  &:hover {
    cursor: pointer;
    box-shadow: 0px 1px 6px 0px #484848;
  }
`

export const CheckStep = styled(Icon)`
  position: absolute;
  right: -2px;
  top: -2px;
  background: #59ce25;
  border-radius: 25px;
  padding: 4px;
  font-size: 8px;
  color: black;
`

export const ListReview = styled.div`
  display: flex;
  margin-top: 12px;
`

export const ReviewCard = styled.div`
  text-align: center;
  border-radius: 5px;
  margin-right: 22px;
  padding: 6px 4px;
  position: relative;
  opacity: 1;
  background: #ffffff47;
  transition: all .25s;
  &:hover {
    background: #6484d2;
    opacity: 0.7;
    cursor: pointer;
  }
  &:last-child {
    margin-right: 0px;
  }
`

export const FitLabel = styled.div`
  margin-top: 7px;
  background: #e6f0ff;
  margin-left: -4px;
  margin-right: -4px;
  margin-bottom: -6px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  padding: 4px 6px;
  font-size: 12px;
  font-weight: 500;
  color: black;
`

export const FitProfilesList = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 14px;
`

export const CardFit = styled.div`
  width: fit-content;
  box-shadow: 1px 2px 6px -1px #454545;
  border-radius: 5px;
  display: flex;
  flex-wrap: wrap;
  font-family: Avenir;
  margin-right: 14px;
  margin-bottom: 12px;
  background: white;
  color: #5F6062;
  opacity: ${({ secondary }: DivProps) => secondary ? '1' : '0.86'};
  transition: all .25s;
  &:last-child {
    @media(min-width: 768px) {
      margin-right: 0px;
    }
  }
  &:hover {
    opacity: 1;
    cursor: pointer;
  }
`

export const CardFitContainer = styled.div`
  padding-top: 1px;
  position: relative;
  max-width: 418px;
  @media(max-width: 768px) {
    width: 85vw;
  }
`

export const TopLabel = styled.div`
  background: whitesmoke;
  padding: 6px 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

export const ExpandableArea = styled.div`
  display: block;
  width: 100%;
  @media(max-width: 768px) {
    display: none;
  }
`

export const ShowMoreLabel = styled.div`
  border: 1px solid #0f84ba;
  padding: 1px 8px;
  color: #0f84ba;
  display: none;
  background-color: white;
  @media(min-width: 320px) and (max-width: 768px) {
    display: block;
  }
`

export const LeftDiv = styled.div`
  width: 120px;
  font-size: 12px;
`

export const RightDiv = styled.div`
  width: 64px;
  font-size: 12px;
`

export const GenderLabel = styled.div`
  flex: 1;
  text-align: center;
  font-size: 12px;
`

export const MetricArea = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 6px 16px 0;
  column-gap: 16px;
`

export const FieldDiv = styled.div`
  display: flex;
  margin-bottom: 10px;
`

export const PayCompletedImg = styled.img`
  width: 100%;
  max-width: 198px;
  animation: fade-in-bottom 0.6s cubic-bezier(0.390, 0.575, 0.565, 1.000) 0.5s both;
  @keyframes fade-in-bottom {
    0% {
      transform: translateY(10px);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
`

export const PayCompleteInfo = styled.div`
  margin-bottom: 12px;
  font-weight: bold;
  font-size: 15px;
  color: #285169;
  font-family: Avenir-Medium;
`

export const DescSizeRec = styled.div`
  margin-top: 6px;
  max-width: 582px;
  ol {
    list-style-type: none;
    counter-reset: item;
  }
  li {
    margin-bottom: 14px;
  }
  li::before {
    font-weight: bold;
    font-size: 22px;
    content: counter(item) " ";
    counter-increment: item;
    margin-left: -26px;
    margin-right: 6px;
    position: relative;
    top: 6px;
  }
  span {
    color: #f15555;
  }
`

export const PolicyDesc = styled.div`
  max-width: 580px;
  margin-bottom: 6px;
  font-style: italic;
  background: #f5f5f5;
  display: inline-block;
  padding: 4px 12px;
  border-radius: 5px;
  font-weight: normal;
  margin-top: 16px;
  a {
    color: cornflowerblue;
  }
`

export const GenderButtons = styled.div`
  border-top: 1px solid #f1f1f1;
  border-radius: 5px;
  box-shadow: 0px 1px 4px -1px #959595;
  width: fit-content;
  display: inline-block;
  font-size: 10px;
  @media (max-width: 698px) {
    position: absolute;
    top: -26px;
    right: 10px;
  }
`

export const MaleButton = styled(Icon)`
  color: #2196f3;
  padding: 6px 8px;
  border-right: 1px solid lightgray;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  transition: all .25s;
  ${({ secondary }: DivProps) => secondary ? `
    box-shadow: inset 0px 1px 3px 0px #b1b1b1, 0px 0px 2px 1px #ffffff;
    border-bottom: 1px solid #e2e2e2;
  ` : ''}
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`

export const FemaleButton = styled(Icon)`
  color: deeppink;
  padding: 6px 8px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  transition: all .25s;
  ${({ secondary }: DivProps) => secondary ? `
    box-shadow: inset 0px 1px 3px 0px #b1b1b1, 0px 0px 2px 1px #ffffff;
    border-bottom: 1px solid #e2e2e2;
  ` : ''}
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`

export const NewMeasure = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 264px;
  background: #fafafa;
  border: 1px dashed darkgray;
  border-radius: 5px;
  margin-bottom: 12px;
  margin-left: 12px;
  min-height: 148px;
  color: gray;
  &:hover {
    cursor: pointer;
    border: 1px solid cornflowerblue;
  }
`

export const InputField = styled.div`
  margin-top: 10px;
  min-width: 96px;
  .labelField {
    color: gray;
    margin-bottom: 2px;
  }
  select {
    background: #ebebeb;
    border: none;
    border-radius: 25px;
    padding: 2px 8px;
  }
`

export const StyledInput = styled.input`
  border: none;
  background: #ebebeb;
  border-radius: 3px;
  padding: 4px;
  max-width: 84px;
`

export const RecSizeSelectionContainer = styled.div`
  position: absolute;
  line-height: normal;
  background: #000000b3;
  width: 100%;
  left: 0;
  top: 100%;
  z-index: 10;
  display: flex;
  flex-flow: column;
  align-items: center;
  color: white;
  #titleLabel {
    font-size: 13px;
  }
  @media (min-width: 320px) and (max-width: 748px) {
    display: none;
  }
  ${({ secondary }: DivProps) => secondary ? `
    height: 42px;
    min-height: 42px;
    #titleLabel, #designCntr {
      overflow: hidden;
    }
  ` : ''};
`

export const TopLabelContainer = styled.div`
  flex: 1;
  width: 100%;
  text-align: center;
  padding: 6px 0;
  font-weight: bold;
  font-size: 18px;
`

export const SizeRecDesignContainer = styled.div`
  display: flex;
  column-gap: 12px;
  padding: 0px 0px 0px 20px;
  margin-block: 12px;
`

export const DesignItemContainer = styled.div`
  width: 148px;
  background-color: #00000014;
  border: 1px dashed #9f9f9f;
  border-radius: 5px;
`

export const DesignSelectedItemContainer = styled.div`
  width: 154px;
  background-color: #fdfdfd;
  display: flex;
  flex-direction: column;
  row-gap: 4px;
  align-items: center;
  position: relative;
  padding: 1px 0px 6px;
  border-radius: 5px;
`

export const DesignItemActionContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 14px;
  justify-content: flex-end;
  margin-left: 12px;
  font-family: Avenir;
  margin-bottom: 2px;
  #ctrLbl {
    align-self: flex-start;
    margin-left: 2px;
    font-size: 12px;
    span {
      font-weight: bold;
      font-size: 16px;
    }
  }
`

export const DesignItemContinueAction = styled.div<{visibility?: boolean}>`
  padding: 6px 32px;
  text-align: center;
  color: #2a2a2a;
  background-color: ${props => props.visibility ? 'white' : '#838383'};
  border-radius: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 12px;
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`

export const DesignItemCancelAction = styled.div`
  padding: 5px 37px;
  text-align: center;
  color: #bfbfbf;
  border: 1px solid #bfbfbf;
  border-radius: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 12px;
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`

export const DesignThumbnail = styled.img`
  width: 100%;
  height: 100px;
  object-fit: cover;
  background: #dedede;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
`

export const DesignCode = styled.span`
  display: block;
  font-size: 10px;
  color: gray;
`

export const DesignProductName = styled.span`
  display: block;
  font-size: 11px;
  color: gray;
`

export const DesignName = styled.span`
  display: block;
  font-weight: 600;
  font-size: 12px;
  color: black;
`

export const DeleteIconContainer = styled.div`
  position: absolute;
  top: 6px;
  right: 6px;
  cursor: pointer;
  font-size: 14px;
  color: white;
`

export const CollapseButton = styled(Icon)`
  position: absolute;
  bottom: -12px;
  background: white;
  border-radius: 50%;
  padding: 6px;
  box-shadow: 0px 2px 3px -1px #717171;
  font-size: 12px;
  color: #626262;
  &:hover {
    cursor: pointer;
  }
`

export const Step = styled.div`
  background: #eeeeee;
  color: #5f6062;
  width: 114px;
  text-align: center;
  padding: 6px 0;
  border-right: 1.5px solid #ffffff;
  transition: all .25s;
  &:last-child {
    border-right: none;
    border-top-right-radius: 25px;
    border-bottom-right-radius: 25px;
  }
  &:first-child {
    border-left: none;
    border-top-left-radius: 25px;
    border-bottom-left-radius: 25px;
  }
  ${({ secondary }: DivProps) => secondary ? `
    background: #34C759;
    color: #312E2E;
    font-weight: bold;
  ` : ''}
`

export const FlexDiv = styled.div`
  display: flex;
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/SizeRecModal/styledComponents.tsx